module.exports = __webpack_public_path__ + "static/media/custom.171a4791.svg";